import styled from "styled-components";

export const StyledCardTitle = styled.h3`
    font-size: var(--size-14);
    margin: 0;
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: bold;
    color: var(--color-secondary);
`;

export default StyledCardTitle;
